import React from "react";
import { CONTACT } from "@/lib/policyMeta";

const WhatsAppIcon = ({ className = "w-7 h-7" }) => (
  <svg viewBox="0 0 32 32" fill="currentColor" className={className} aria-hidden="true">
    <path d="M16.004 3C8.832 3 3 8.832 3 16.004c0 2.3.61 4.54 1.77 6.51L3 29l6.66-1.74A12.94 12.94 0 0 0 16.004 29C23.168 29 29 23.168 29 16.004 29 8.832 23.168 3 16.004 3zm0 23.5a10.45 10.45 0 0 1-5.33-1.46l-.38-.23-3.95 1.03 1.05-3.85-.25-.4a10.47 10.47 0 0 1-1.61-5.55c0-5.79 4.71-10.5 10.47-10.5s10.5 4.71 10.5 10.5-4.71 10.46-10.5 10.46zm5.75-7.84c-.31-.16-1.86-.92-2.15-1.02-.29-.11-.5-.16-.71.16-.21.31-.82 1.02-1 1.23-.18.21-.37.23-.68.08-.31-.16-1.32-.49-2.51-1.55-.93-.83-1.55-1.85-1.73-2.16-.18-.31-.02-.48.14-.63.14-.14.31-.37.47-.55.16-.18.21-.31.31-.52.11-.21.05-.39-.03-.55-.08-.16-.71-1.71-.97-2.34-.26-.62-.52-.53-.71-.54h-.61c-.21 0-.55.08-.84.39-.29.31-1.1 1.08-1.1 2.63s1.13 3.05 1.29 3.26c.16.21 2.22 3.39 5.38 4.75 2.52 1.09 3.03.87 3.58.82.55-.05 1.86-.76 2.12-1.5.26-.73.26-1.36.18-1.5-.08-.13-.29-.21-.61-.37z" />
  </svg>
);

const WhatsAppFloat = () => {
  const href = `${CONTACT.whatsappHref}?text=${encodeURIComponent(
    "Hi Oori Label, I have a question about your collection."
  )}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      data-testid="whatsapp-float"
      className="fixed z-[60] bottom-[max(1.25rem,env(safe-area-inset-bottom))] right-[max(1.25rem,env(safe-area-inset-right))] sm:bottom-8 sm:right-8 inline-flex items-center justify-center w-14 h-14 sm:w-[3.75rem] sm:h-[3.75rem] rounded-full bg-[#25D366] text-white shadow-[0_8px_24px_rgba(37,99,54,0.35)] hover:bg-[#1ebe57] hover:scale-105 active:scale-95 transition-all duration-200"
    >
      <WhatsAppIcon className="w-7 h-7 sm:w-8 sm:h-8" />
    </a>
  );
};

export default WhatsAppFloat;
